import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nama Bank", -1)
const _hoisted_3 = { class: "invalid-feedback" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-1" }, "Aktif", -1)
const _hoisted_6 = { class: "container-btn-action" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Simpan")

import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import { Form, Field } from 'vee-validate'
import vSelect from 'vue-select'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import InputSwitch from 'primevue/inputswitch'
import { onMounted, getCurrentInstance, ref, computed } from 'vue'
import { IBankForm } from '@/utils/interfaces/iBank'
import apiUseCase from '@/usecase/apiUseCase'
import { isNull } from 'lodash'
import rgxExp from '@/utils/helpers/regExp'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const moduleStore = 'hjpTable'
const endpoint = '/management/v1/MsBank'
const store = useStore()
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const dataForm = ref()
const idPrams = computed(() => store.state[moduleStore].modal?.data?.Id)

const initialValues: IBankForm = {
  Name: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.Name : '',
  IsActive: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.IsActive : true
}

const schema = Yup.object().shape({
  Name: Yup.string()
    .required('Nama Bank harus diisi!')
    .max(50, 'Nama Bank tidak boleh melebihi 50 karakter')
    .matches(rgxExp.notPrefixSpace, 'Nama Bank tidak boleh hanya menggunakan spasi')
    .test('unique-name', 'Nama Bank sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['name']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Name === val)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.Name
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    })
})

const onSubmit = (values: any) => {
  console.log('masukk submit', values)
  // eslint-disable-next-line no-use-before-define
  processSubmit(values)
}

const hideSidebar = () => {
  store.dispatch('setShowModal', false)
  store.dispatch('setTitleFormSidebar', null)
}

const changeOk = (val: any) => {
  console.log('valll', val)
}

const onSearchOption = (search: any, loading: any) => {
  console.log('search', search)
}

const onSelectedBank = (selected: any) => {
  console.log('selected', selected)
}

const processSubmit = async (val: any) => {
  store.dispatch('showLoading')
  console.log('val', val)

  if (isNull(store.state.hjpTable.modal.data)) {
    dataForm.value = {
      Name: val.Name,
      IsActive: val.IsActive
    }
  } else {
    dataForm.value = {
      Id: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.Id : '',
      Name: val.Name,
      IsActive: val.IsActive,
    }
  }
  const response = isNull(store.state.hjpTable.modal.data) ? await apiUseCase.postOrPut(endpoint, null, dataForm.value) : await apiUseCase.postOrPut(endpoint, store.state.hjpTable.modal.data.Id, dataForm.value)
  if (!response.error) {
    $toast.add({
      severity: 'success',
      detail: isNull(store.state.hjpTable.modal.data) ? 'Data Berhasil Ditambahkan' : 'Data Berhasil Diubah',
      group: 'bc',
      closable: false,
      life: 3000
    })
  } else {
    $toast.add({
      severity: 'error',
      detail: isNull(store.state.hjpTable.modal.data) ? 'Data Gagal Ditambahkan' : 'Data Gagal Diubah',
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  store.dispatch('setShowModal', false)
  store.dispatch('setReloadDataTable', true)
  store.dispatch('setTitleFormSidebar', null)
  store.dispatch('hideLoading')
}

onMounted(() => {
  console.log('store', store.state)
  let titleForm = 'Tambah'
  if (store.state.hjpTable.modal.data) {
    titleForm = 'Edit'
  }
  store.dispatch('setTitleFormSidebar', `${titleForm} Bank`)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Form), {
      onSubmit: onSubmit,
      "validation-schema": _unref(schema),
      "initial-values": initialValues,
      class: "form-container"
    }, {
      default: _withCtx(({ errors, setFieldValue, values }) => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_unref(Field), { name: "Name" }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(_unref(InputText), _mergeProps(field, {
                modelValue: values.Name,
                "onUpdate:modelValue": ($event: any) => ((values.Name) = $event),
                onChange: handleChange,
                onBlur: handleBlur,
                class: `input-primary ${errors.Name ? 'input-invalid' : ''}`,
                placeholder: "Nama Bank",
                autocomplete: "off",
                maxlength: 50
              }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "class"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_3, _toDisplayString(errors.Name), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_unref(Field), { name: "IsActive" }, {
            default: _withCtx(({ field }) => [
              _createVNode(_unref(InputSwitch), _mergeProps({ class: "input-success" }, field, {
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                inputId: "isactive"
              }), null, 16, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (hideSidebar()))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            type: "submit",
            class: "btn-primary mr-1"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"])
  ]))
}
}

})